module.exports = __webpack_public_path__ + "static/media/mercedes_07.13400fb4.png";